import React from 'react';
import SetForm from "./../../../Common/SetForm";
import Form from "./../../../../lib/FieldForm";
import { PParamsData } from "./../../../../../platform.es.config";
import { getFEWalletParams } from "./../../../../../platform.pay.config";
import { CommonPostPay, setDefaultBank, InsertNewAccountHolderName } from "./../../../../lib/api/api.data";
import { withdrawModalHandle } from "./../../../../lib/data/withdrawKyc.static"
import translate from "./../../../../lib/translate/TranslateJs";

class LB extends SetForm {
    constructor(props) {
        super(props);
        this.state = {
            ...this.commonState,
            depositMoney: 0,
            memberTotalBank: []
        };

        this.typeCode = "LB";
        this.memberBank = {}; // 记录选中的会员银行卡信息
        this.transactionId = ""; // 订单编号

        this.feWalletParams = getFEWalletParams();

    }
    componentDidMount() {
        this.didMount();
        this.feWalletParams.webPiwikUrl("withdrawal_lb", "Withdrawal LB")
    }
    componentDidUpdate(prevProps, prevState) {
        this.didUpdate(prevProps, prevState);
    }
    componentWillUnmount() {
        this.willUnmount();
    }
    submitOnce = async (values) => {

        if (!this.props.withdrawalStatusCheck(this.typeCode)) return;
        this.setState({
            submitDisabled: true
        });
        setTimeout(()=>{
            this.setState({
                submitDisabled: false
            });
        }, 3000);
        this.props.setLoading(true);
        //let { platformType, languageType, device } = this.feWalletParams
        let { language, swiftCode, isMobile } = PParamsData()
        CommonPostPay(
            {
                depositingBankName: values.bankaccount || "",
                accountNumber: this.memberBank.accountNumber,
                accountHolderName: this.memberBank.accountHolderName, // 确认下要传递什么名称
                bankName: this.memberBank.bankName,
                city: this.memberBank.city,
                province: this.memberBank.province,
                branch: this.memberBank.branch,
                language,
                swiftCode,
                paymentMethod: this.typeCode,
                charges: 0,
                amount: values.money,
                transactionType: "Withdrawal",
                domainName: this.feWalletParams.domainName,
                isMobile,
                isSmallSet: !!values.isSetDefault,
                successUrl: this.feWalletParams.successUrl,
                seonSession: await this.feWalletParams.getSeonSession(),
                // maxPayoutDurationInMins: 300,  P2 INCIDENT-56545
                // payoutDurationRebatePercent: 0.1
            },
            (res) => {

                this.props.setLoading(false);

                if (res.isSuccess) {
                    this.feWalletParams?.reloadBalance()
                    const RESULT = res.result;
                    this.feWalletParams?.toggleHideWithdrawHeader && this.feWalletParams?.toggleHideWithdrawHeader(false)//app mobile 提款成功后， 用于隐藏上方的header

                    // typeof this.applyBonusCallback === "function" && this.applyBonusCallback({
                    //     transactioinType: "Deposit",
                    //     ...values,
                    //     ...RESULT
                    // });

                    this.transactionId = RESULT.transactionId;

                    this.setStep(2);
                    this.setDepositTime(RESULT.submittedAt);
                    this.setState({ depositMoney: values.money });


                    Array.isArray(this.state.memberTotalBank) && this.state.memberTotalBank.filter(v => v.type !== 'push').length > 1 && !!values.isSetDefault && !this.memberBank.isDefault && setDefaultBank(this.memberBank.bankAccountID)

                } else {
                    this.setState({
                        submitDisabled: true
                    })
                    withdrawModalHandle({
                        res,
                        PendingWithdraw: this.props.PendingWithdraw,
                        WithdrawKycModal: this.props.WithdrawKycModal,
                        InsertNewAccountHolderName: () => { InsertNewAccountHolderName(this.memberBank.accountHolderName) },
                        accountHolderName: this.memberBank.accountHolderName,
                        firstName: this.props.memberInfo.firstName,
                        methods: 'LB'
                    })
                }

                // depositErrPrompt(RESULT);
            }
        );

        // Pushgtagdata("Deposit", "Submit", `Submit_${this.typeCode}_Deposit​`);
    }

    goHome = () => {
        this.setState({ step: 1 }, () => {
            this.formInstance.setFieldValue("money", "");
        });
    }

    render() {

        const {
            WithdrawalSuccessTimer,
            WithdrawalMoney,
            BankAccount,
            MemberBanks,
            SetDefault,
            SubmitBtn,
            FormType,
            Input,
            Item,
            style = {},
        } = this.props;

        const {
            setDepositDetail,
            currAvailableMethods,
            currDepositDetail // 当前充值方式详细数据
        } = this.props;
         //只有M2使用isSingleDeposit判断能不能添加银行卡,isSingleDeposit = true无法添加
        const isSingleDeposit = this.feWalletParams.languageType == 'M2'? this.props.memberInfo?.isSingleDeposit: false
        const commonParams = {
            Item: Item,
            Input: Input,
            showAddUserBank: !isSingleDeposit,
            form: this.formInstance,
            typeCode: this.typeCode,
            setting: currDepositDetail.setting,
            setLoading: this.props.setLoading,
            setCurrFormData: this.setCurrFormData
        };

        const { setting } = commonParams;

        return <>
            {this.state.step === 1 ? <Form
                component={FormType}
                ref={(form) => { form && (this.setFormInstance(form)) }}
                onFieldsChange={this.setSubmitButtonStatus}
                onFinish={(values) => {
                    this.submitOnce(values);
                }}
                style={style}
            >
                <WithdrawalMoney
                    uniqueAmountStatus={this.props.uniqueAmountStatus}
                    allowDecimals={false}
                    {...commonParams}
                />
                {setting && !setting.isAutoAssign ? <BankAccount
                    label={translate("银行选择")()}
                    bankIconName="enBankName"
                    suffixNoParam="accountNo"
                    notRequired={true}
                    setFormStaticData={this.formStaticData.setData}
                    bankAccounts={currDepositDetail && currDepositDetail.bankAccounts}
                    {...commonParams}
                /> : null}
                <MemberBanks
                    setCurrMemberBank={(data) => { this.memberBank = data }}
                    getMemberTotalBank={memberTotalBank => { this.setState({ memberTotalBank }) }}
                    {...commonParams}
                />

                {/* {
                    Array.isArray(this.state.memberTotalBank) && <Item fieldName="isSetDefault" initialValue={this.state.memberTotalBank.length > 0 ? 1 : 0}>
                        {(control) => (
                            <SetDefault
                                value={control.value}
                                onClick={() => { control.onChange(control.value === 1 ? 0 : 1) }}
                            />
                        )}
                    </Item>
                } */}

                <SubmitBtn
                    disabled={this.state.submitDisabled}
                    onClick={() => {
                        this.formInstance && this.formInstance.submit();
                    }}
                />
            </Form> : null}
            {this.state.step === 2 ? <WithdrawalSuccessTimer
                goHome={this.goHome}
                goBack={this.goBack}
                type={"LB"}
                LivechatClick={() => {
                    this.goBack
                    this.feWalletParams.LivechatClick()
                }}
                transactionId={this.transactionId}
                depositMoney={this.state.depositMoney}
                depositDateTime={this.state.depositDateTime}
                clearDateTime={this.clearDateTime}
            /> : null}
        </>
    }
}

export default LB;
